import styled from "styled-components"

export const Paragraphs = styled.div``

export const Outer = styled.div`
  margin: 0;
`

export const Title = styled.div`
  margin: 1em 0;
`

export const Body = styled.div`
  margin: 1em 0;
`

export const Text = styled.div`
  margin-bottom: 100px;
`
export const Media = styled.div`
  margin-bottom: 100px;
`
